// Pili brand colors
const _PILI_BLUE = "#1C3D55";
const PILI_LIME = "#C9DD3B";
const PILI_DARK = "#0b0c0f";
const PILI_MUTED = "#5A5A5A";
const PILI_LIGHT_BLUE_BG = "#eaf2ff";

const styles: Record<string, React.CSSProperties> = {
  container: {
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "24px",
    backgroundColor: PILI_LIGHT_BLUE_BG,
    fontFamily: "'Oswald', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  },
  logo: {
    width: "80px",
    height: "80px",
    borderRadius: "16px",
    marginBottom: "24px",
    objectFit: "contain" as const,
  },
  title: {
    fontSize: "36px",
    fontWeight: "700",
    color: PILI_DARK,
    marginBottom: "16px",
    textAlign: "center" as const,
  },
  subtitle: {
    fontSize: "18px",
    color: PILI_MUTED,
    marginBottom: "32px",
    textAlign: "center" as const,
    maxWidth: "400px",
    lineHeight: "1.5",
  },
  footer: {
    position: "absolute" as const,
    bottom: "32px",
    display: "flex",
    gap: "24px",
    alignItems: "center",
  },
  footerLink: {
    fontSize: "14px",
    color: PILI_MUTED,
    textDecoration: "none",
    transition: "color 0.2s ease",
  },
  footerDivider: {
    width: "4px",
    height: "4px",
    borderRadius: "50%",
    backgroundColor: PILI_LIME,
  },
};

/**
 * HomePage - Marketing landing page
 *
 * Simple placeholder for the main marketing site.
 */
export default function HomePage() {
  return (
    <div style={styles.container}>
      <img src="/app-icon.png" alt="Pili" style={styles.logo} />

      <h1 style={styles.title}>Pili</h1>
      <p style={styles.subtitle}>Simple, direct payments.</p>

      <footer style={styles.footer}>
        <a href="/terms" style={styles.footerLink}>
          Terms
        </a>
        <div style={styles.footerDivider} />
        <a href="/privacy" style={styles.footerLink}>
          Privacy
        </a>
        <div style={styles.footerDivider} />
        <a href="/support" style={styles.footerLink}>
          Support
        </a>
      </footer>
    </div>
  );
}
